var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuspicious(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13685_29055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.866514C7.4282 0.330615 8.5718 0.330615 9.5 0.866514L13.4282 3.13446C14.3564 3.67036 14.9282 4.66074 14.9282 5.73254V10.2684C14.9282 11.3402 14.3564 12.3306 13.4282 12.8665L9.5 15.1345C8.5718 15.6704 7.4282 15.6704 6.5 15.1345L2.5718 12.8665C1.64359 12.3306 1.0718 11.3402 1.0718 10.2684V5.73254C1.0718 4.66074 1.64359 3.67036 2.5718 3.13446L6.5 0.866514Z",
    fill: "#F54822"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.125,
    height: 4.25,
    transform: "matrix(1 0 0 -1 7 8.50049)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.125,
    height: 2.125,
    transform: "matrix(1 0 0 -1 7 11.9692)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13685_29055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.000488281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspicious);
export default __webpack_public_path__ + "static/media/Suspicious.140081d4274b4472dfe98084c027007f.svg";
export { ForwardRef as ReactComponent };